import type {NutrientSlug} from '../../modules/food-diary';
import type {
  CoreClientFoodDiaryCreateParams,
  CoreClientFoodDiaryDeleteParams,
  CoreClientFoodDiaryListParams,
  CoreClientFoodDiaryReadParams,
  CoreClientFoodDiaryStatsParams,
  CoreClientFoodDiaryUpdateParams,
} from '../types/core/methods';
import type {FoodDiaryExpandedCommon} from './types';

import {expandResponse} from '../../services/entity-action/utils';
import {not} from '../../utils/conditionalUtils';
import {isDefined} from '../../utils/typecheck';
import {apiRequest} from '../utils/apiRequest';
import {EntityStore} from '../utils/entityStore';
import {foodDiaryExpandCommon} from './expand';

class FoodDiaryStore<
  T extends FoodDiaryExpandedCommon = FoodDiaryExpandedCommon,
> extends EntityStore<
  T,
  CoreClientFoodDiaryReadParams,
  CoreClientFoodDiaryCreateParams,
  CoreClientFoodDiaryUpdateParams,
  CoreClientFoodDiaryDeleteParams
> {
  async fetchList(params: CoreClientFoodDiaryListParams) {
    if (not(isDefined(params.expand))) {
      params.expand = foodDiaryExpandCommon;
    }

    const response = await apiRequest({
      method: 'client.food_diary.list',
      params,
    });

    return expandResponse(response, {
      params,
    }) as FoodDiaryExpandedCommon[];
  }

  async fetchStats(params: CoreClientFoodDiaryStatsParams) {
    type ClientFoodDiaryStatsResponse = {
      food_nutrients_items: Record<NutrientSlug, number>[];
    };

    const response = (await apiRequest({
      method: 'client.food_diary.stats',
      params,
    })) as ClientFoodDiaryStatsResponse;

    return response.food_nutrients_items;
  }
}

export const foodDiaryStore = new FoodDiaryStore('food_diary', {
  create: 'client.food_diary.create',
  delete: 'client.food_diary.delete',
  fetch: 'client.food_diary.read',
  update: 'client.food_diary.update',
});
